import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    loading: false,
    error: null,
}

export const BoundarySlice = createSlice({
    name: 'BoundarySlice',
    initialState,
    reducers: {
        changeLoading: (state, action) => {
            state.loading = action.payload
        },
        addError: (state, action) => {
            state.error = action.payload
        },
    },
    extraReducers: {},
})
